import { Dispatch, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";

interface InitialState {
    viewerTreeVisibility: boolean;
    viewerPropsVisibility: boolean;
}
const initialState: InitialState = {
    viewerTreeVisibility: false,
    viewerPropsVisibility: false,
};

const slice = createSlice({
    name: "buttons-slice",
    initialState,
    reducers: {
        setViewerTreeVisibility: (state, action: PayloadAction<boolean>) => {
            state.viewerTreeVisibility = action.payload;
        },
        toggleViewerTreeVisibility: (state) => {
            state.viewerTreeVisibility = !state.viewerTreeVisibility;
        },
        setViewerPropsVisibility: (state, action: PayloadAction<boolean>) => {
            state.viewerPropsVisibility = action.payload;
        },
        toggleViewerPropsVisibility: (state) => {
            state.viewerPropsVisibility = !state.viewerPropsVisibility;
        },
    },
});

export default slice.reducer;
export const {
    setViewerTreeVisibility,
    toggleViewerTreeVisibility,
    setViewerPropsVisibility,
    toggleViewerPropsVisibility,
} = slice.actions;

export const selectViewerTreeVisibility = (state: RootState) =>
    state.viewerButtons.viewerTreeVisibility;

export const selectViewerPropsVisibility = (state: RootState) =>
    state.viewerButtons.viewerPropsVisibility;
